(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/init-store.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/init-store.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createApi,
  fetchBaseQuery
} = window.RTKQ;
const {
  jupiterFetch
} = svs.core;
const {
  role
} = svs.core.session.data.userSession;
const {
  isCorporateSite
} = svs.grassroots.shared.data;
const sumYearlyStatistics = statistics => {
  const yearlystatistics = [];
  statistics.reverse().forEach(year => {
    let totalPayment = null;
    year.monthlystatistics.forEach(month => {
      if (month.payment !== null) {
        totalPayment += month.payment.totalamount;
      }
    });
    if (totalPayment !== null) {
      yearlystatistics.push({
        year: year.year,
        totalPayment
      });
    }
  });
  return yearlystatistics;
};
const fetchAndSumYearlyStatistics = async (selections, fetchWithBQ) => {
  const receiversIds = _.map(selections, receiver => receiver.id).join(',');
  const receiverInfos = await fetchWithBQ({
    url: 'player/1/sponsorship/receiverinfo',
    params: {
      receivers: receiversIds,
      includeStatisticsInReply: true
    }
  });
  if (receiverInfos.error) {
    return {
      error: receiverInfos.error
    };
  }
  receiverInfos.data.receivers.forEach(receiverInfo => {
    selections.forEach(selection => {
      if (receiverInfo.id === selection.id && (receiverInfo === null || receiverInfo === void 0 ? void 0 : receiverInfo.yearlystatistics) !== null) {
        selection.yearlystatistics = sumYearlyStatistics(receiverInfo.yearlystatistics);
      }
    });
  });
  return selections;
};
const grassrootsQueryApi = createApi({
  reducerPath: 'grassrootsQuery',
  baseQuery: fetchBaseQuery({
    baseUrl: "".concat(jupiterFetch.url()),
    fetchFn: jupiterFetch.fetch
  }),
  endpoints: builder => ({
    fetchTopSelections: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const topSelectionsFetch = await fetchWithBQ({
          url: '/player/1/sponsorship/topselections',
          params: {
            sortKey: arg,
            categories: '["Idrottsförening"]',
            numRows: 3,
            offset: 0
          }
        });
        if (topSelectionsFetch.error) {
          return {
            error: topSelectionsFetch.error
          };
        }
        const topSelections = await fetchAndSumYearlyStatistics(topSelectionsFetch.data.categories[0].topSelections, fetchWithBQ);
        return {
          data: topSelections
        };
      }
    }),
    fetchLastPicked: builder.query({
      async queryFn() {
        let arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
        let _queryApi = arguments.length > 1 ? arguments[1] : undefined;
        let _extraOptions = arguments.length > 2 ? arguments[2] : undefined;
        let fetchWithBQ = arguments.length > 3 ? arguments[3] : undefined;
        const lastSelectionsFetch = await fetchWithBQ({
          url: '/player/1/sponsorship/lastselected'
        });
        if (lastSelectionsFetch.error) {
          return {
            error: lastSelectionsFetch.error
          };
        }
        if (lastSelectionsFetch.data.latestSelections.length > arg) {
          return {
            data: lastSelectionsFetch.data.latestSelections.splice(0, arg)
          };
        }
        return {
          data: lastSelectionsFetch.data.latestSelections
        };
      }
    }),
    fetchUserSelection: builder.query({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        if (isCorporateSite || role !== svs.core.session.data.userSession.roles.PLAYER) {
          return {
            data: []
          };
        }
        const userSelection = await fetchWithBQ({
          url: '/player/1/sponsorship/receiverselection',
          params: {
            active: true
          }
        });
        if (userSelection.error) {
          return {
            error: userSelection.error
          };
        }
        return {
          data: userSelection.data.receivers
        };
      }
    }),
    fetchReceiversSearch: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        var _arg$numResponses;
        if (!(arg !== null && arg !== void 0 && arg.searchterm)) {
          return {
            data: {
              receivers: [],
              numberfound: 0
            }
          };
        }
        const numResponses = Math.min(50, (_arg$numResponses = arg === null || arg === void 0 ? void 0 : arg.numResponses) !== null && _arg$numResponses !== void 0 ? _arg$numResponses : 5);
        const searchReceiversFetch = await fetchWithBQ({
          url: '/player/1/sponsorship/search',
          params: {
            search: arg.searchterm,
            offset: 0,
            numResponses
          }
        });
        if (searchReceiversFetch.error) {
          return {
            error: searchReceiversFetch.error
          };
        }
        return {
          data: {
            receivers: searchReceiversFetch.data.receivers,
            numberfound: searchReceiversFetch.data.numberfound
          }
        };
      },
      transformResponse: (response, meta) => ({
        data: response,
        numberfound: meta.numberfound
      })
    }),
    fetchReceiversById: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const searchReceiversFetch = await fetchWithBQ({
          url: '/player/1/sponsorship/receiverinfo',
          params: {
            receivers: arg
          }
        });
        if (searchReceiversFetch.error) {
          return {
            error: searchReceiversFetch.error
          };
        }
        const response = await fetchAndSumYearlyStatistics(searchReceiversFetch.data.receivers, fetchWithBQ);
        return {
          data: response
        };
      }
    }),
    fetchReceiverSelection: builder.query({
      query: () => ({
        url: '/player/1/sponsorship/receiverselection',
        params: {
          active: true
        }
      }),
      transformResponse: response => response.receivers
    }),
    setReceiverSelection: builder.mutation({
      query: id => ({
        url: '/player/1/sponsorship/receiverselection',
        method: 'POST',
        body: {
          receivers: [id]
        }
      })
    }),
    removeReceiverSelection: builder.mutation({
      query: id => ({
        url: '/player/1/sponsorship/receiverselection',
        method: 'DELETE',
        body: {
          receivers: [id],
          includeStatisticsInReply: true
        }
      })
    }),
    replaceReceiverSelection: builder.mutation({
      query: body => ({
        url: '/player/1/sponsorship/receiverselection',
        method: 'PUT',
        body: _objectSpread(_objectSpread({}, body), {}, {
          includeStatisticsInReply: true
        })
      })
    }),
    fetchContentByIds: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        if (arg.length === 0) {
          return {
            data: []
          };
        }
        const contentByIdsFetch = await fetchWithBQ({
          url: '/content/2/id',
          params: {
            ids: arg,
            routesDomain: svs.core.detect.tenant('lb') ? 'spela' : 'tur'
          }
        });
        if (contentByIdsFetch.error) {
          return {
            error: contentByIdsFetch.error
          };
        }
        return {
          data: contentByIdsFetch.data.result
        };
      }
    }),
    fetchStatistics: builder.query({
      async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
        const statisticsFetch = await fetchWithBQ({
          url: '/player/1/sponsorship/statistics'
        });
        if (statisticsFetch.error) {
          return {
            error: statisticsFetch.error
          };
        }
        return {
          data: statisticsFetch.data
        };
      }
    })
  })
});
const MOST_SUPPORTERS = 1;
const MOST_POINTS = 2;
svs.grassroots.store = {
  grassrootsQueryApi,
  MOST_SUPPORTERS,
  MOST_POINTS
};

 })(window);